import type { CalendarSessionInput, CoachChatResponse } from '@/lib/api';

/**
 * Extracts calendar sessions from a CoachChatResponse.
 * Prefers season_plan.calendar_sessions, falls back to planned_weeks.
 */
export function extractCalendarSessions(response: CoachChatResponse): CalendarSessionInput[] {
  const calSessions = response.season_plan?.calendar_sessions;
  if (calSessions && calSessions.length > 0) {
    return calSessions.map((s) => ({
      date: s.date,
      workout_type: s.workout_type,
      duration_or_structure: s.duration_or_structure ?? '',
      notes: s.notes ?? '',
    }));
  }

  if (response.planned_weeks && response.planned_weeks.length > 0) {
    const sessions: CalendarSessionInput[] = [];
    for (const week of response.planned_weeks) {
      for (const sess of week.sessions) {
        sessions.push({
          date: sess.date,
          workout_type: sess.type,
          duration_or_structure: `${sess.duration ?? 0} min`,
          notes: sess.notes ?? '',
        });
      }
    }
    return sessions;
  }

  return [];
}

/**
 * Determines whether a CoachChatResponse contains a loadable plan.
 * Use this to conditionally render the button.
 */
export function hasLoadablePlan(response: CoachChatResponse): boolean {
  return extractCalendarSessions(response).length > 0;
}
